import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

// Raisons laissées par les utilisateurs qui suppriment leur compte.
export default function DeletionReasonsTab() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/price/deletion-reasons").then(({ data: d }) => setData(d)).catch(() => setData({ items: [], counts: {} })); }, []);
  if (!data) return <Loader2 className="h-6 w-6 animate-spin" />;
  const total = data.items.length;
  return (
    <div className="space-y-4" data-testid="deletion-reasons-tab">
      <h2 className="font-[Outfit] text-2xl font-black">Raisons des suppressions de compte</h2>
      <div className="flex flex-wrap gap-2" data-testid="deletion-reasons-counts">
        {Object.entries(data.counts).sort((a, b) => b[1] - a[1]).map(([k, n]) => (
          <span key={k} className="rounded-full bg-white px-3 py-1.5 text-[12px] font-black street-border-thin">{k} · {n} ({Math.round((n / total) * 100)} %)</span>
        ))}
      </div>
      {total === 0 ? <p className="rounded-2xl bg-white p-4 text-sm font-semibold street-border-thin">Aucune suppression pour l&apos;instant.</p> : (
        <div className="space-y-2">
          {data.items.map((it) => (
            <div key={it.id} className="rounded-2xl bg-white p-3 street-border-thin" data-testid={`deletion-reason-${it.id}`}>
              <div className="flex flex-wrap justify-between gap-2 text-[12px] font-black">
                <span>{it.reason_category}</span>
                <span className="text-foreground/60">{it.role === "driver" ? "Conducteur" : "Passager"} · {new Date(it.deleted_at).toLocaleDateString("fr-FR")}</span>
              </div>
              <p className="mt-1 text-[13px] font-medium">{it.reason}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
